import { Route } from '@angular/router';

import { BrandsPageComponent } from './core/components/brands-page/brands-page.component';
import { ComparePageComponent } from './core/components/compare-page/compare-page.component';
import { ProductDetailComponent } from './core/components/product-detail/product-detail.component';
import { ProductListComponent } from './core/components/product-list/product-list.component';
import { TechnicalDisclaimerPageComponent } from './core/components/technical-disclaimer-page/technical-disclaimer-page.component';
import { TermsPageComponent } from './core/components/terms-page/terms-page.component';

export const routes: Route[] = [
    {
        path: 'brands',
        component: BrandsPageComponent,
    },
    {
        path: 'category/:slug',
        component: ProductListComponent,
        pathMatch: 'full',
    },
    {
        path: 'search',
        component: ProductListComponent,
    },
    {
        path: 'product/:slug',
        component: ProductDetailComponent,
    },
    {
        path: 'compare',
        component: ComparePageComponent,
    },
    {
        path: 'terms',
        component: TermsPageComponent,
    },
    {
        path: 'technical-disclaimer',
        component: TechnicalDisclaimerPageComponent,
    },
    {
        path: 'account',
        loadChildren: () => import('./account/account.module').then(m => m.AccountModule),
    },
    {
        path: 'checkout',
        loadChildren: () => import('./checkout/checkout.module').then(m => m.CheckoutModule),
    },
];
